import React from 'react';
import ReactDOM from 'react-dom/client'; // 注意：这里从 'react-dom/client' 导入
import App from './App';

// 使用 createRoot 替换 render
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);